import { useState } from "react";

type CopiedValue = string | null;
type CopyFn = (text: string) => Promise<boolean>; // Return success
type notificationB = boolean; // Return success

function useCopyToClipboard(): [CopiedValue, CopyFn, notificationB] {
  const [copiedText, setCopiedText] = useState<CopiedValue>(null);
  const [notification, setNotification] = useState<notificationB>(false);

  const handleCopiedTextChange = (value: string | null) => {
    setCopiedText(value);
    if (value) {
      setNotification(true);
      setTimeout(() => {
        setNotification(false);
      }, 1500);
    }
  };

  const copy: CopyFn = async text => {
    if (!navigator?.clipboard) {
      return false;
    }

    // Try to save to clipboard then save it in the state if worked
    try {
      await navigator.clipboard.writeText(text);
      handleCopiedTextChange(text);
      return true;
    } catch (error) {
      handleCopiedTextChange(null);
      return false;
    }
  };

  return [copiedText, copy, notification];
}

export default useCopyToClipboard;
